import { modelPeriodLevelsCache } from "./modelPeriodLevelsCache";
import { getPeriodLevels } from "./getPeriodLevels";
import { getPeriods } from "./getPeriods";

export const getAllPeriodLevels = async (id: string) => {
  const [SC, mid, elementid] = id.split(".");
  const modelid = `${SC}.${mid}`;

  if (modelPeriodLevelsCache[modelid]) return modelPeriodLevelsCache[modelid];

  const levels = await getPeriodLevels(modelid); // await m.getPeriodLevels(`${modelid}`);
  const periods = (await getPeriods(modelid)).sort((a, b) =>
    a.startdate.localeCompare(b.startdate)
  );

  const value = levels.map((level) => {
    return {
      id: level.id,
      name: level.name,
      periods: periods.filter((p) => p.periodlevel === level.id),
    };
  });
  modelPeriodLevelsCache[modelid] = value;
  return modelPeriodLevelsCache[modelid];
};
